import React from 'react';
import { AlertCircle } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function AuthoritySection() {
  const facts = [{
    title: 'La progesterona desaparece',
    desc: "Pierdes tu 'sedante natural' que te ayudaba a mantener la calma."
  }, {
    title: 'Los estrógenos bajan',
    desc: 'Tu cuerpo produce menos melatonina, la hormona del sueño.'
  }, {
    title: 'Sistema nervioso en alerta',
    desc: 'Tu cuerpo entra en un estado de supervivencia constante.'
  }];
  return <section className="py-24 bg-terracotta text-white relative overflow-hidden" data-id="element-13">
      {/* Subtle background pattern/shadows */}
      <div className="absolute inset-0 opacity-10" data-id="element-14">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-[100px] -translate-x-1/2 -translate-y-1/2" data-id="element-15"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-black rounded-full blur-[100px] translate-x-1/2 translate-y-1/2" data-id="element-16"></div>
      </div>

      <div className="container mx-auto px-6 max-w-5xl relative z-10" data-id="element-17">
        <FadeIn data-id="element-18">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-center mb-16" data-id="element-19">
            Lo que pasa durante la menopausia
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-20">
          {facts.map((fact, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-21">
              <div className="bg-white/10 backdrop-blur-sm border border-white/20 p-8 rounded-2xl h-full shadow-volumetric" data-id="element-22">
                <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mb-6" data-id="element-23">
                  <span className="font-serif font-bold text-xl" data-id="element-24">
                    {index + 1}
                  </span>
                </div>
                <h3 className="text-xl font-bold mb-3 font-serif" data-id="element-25">
                  {fact.title}
                </h3>
                <p className="text-white/80 leading-relaxed" data-id="element-26">{fact.desc}</p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-27">
          <div className="bg-white text-terracotta-dark p-8 rounded-2xl shadow-volumetric max-w-3xl mx-auto flex items-start md:items-center gap-6 flex-col md:flex-row" data-id="element-28">
            <div className="flex-shrink-0 bg-terracotta/10 p-4 rounded-full" data-id="element-29">
              <AlertCircle className="w-8 h-8 text-terracotta" data-id="element-30" />
            </div>
            <div data-id="element-31">
              <h4 className="text-xl md:text-2xl font-serif font-bold mb-2" data-id="element-32">
                Resultado: no puedes dormir aunque estés cansada
              </h4>
              <p className="text-charcoal-light" data-id="element-33">
                Es un problema hormonal y metabólico, no de fuerza de voluntad.
                Necesitas una estrategia específica para esta etapa.
              </p>
              <p className="text-charcoal mt-4 font-medium" data-id="element-34">
                Por eso no es falta de disciplina.{' '}
                <span className="font-bold" data-id="element-35">Es biología.</span> Y necesitas una
                estrategia diferente.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}